var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-list-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF550-copy",
    transform: "translate(0.000000, 2.000000)",
    fill: "#212529",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,2 C0.354166667,2 0.234375,1.953125 0.140625,1.859375 C0.046875,1.765625 0,1.64583333 0,1.5 L0,0.5 C0,0.354166667 0.046875,0.234375 0.140625,0.140625 C0.234375,0.046875 0.354166667,0 0.5,0 L13.5,0 C13.6458333,0 13.765625,0.046875 13.859375,0.140625 C13.953125,0.234375 14,0.354166667 14,0.5 L14,1.5 C14,1.64583333 13.953125,1.765625 13.859375,1.859375 C13.765625,1.953125 13.6458333,2 13.5,2 L0.5,2 Z M15.5,5 C15.6458333,5 15.765625,5.046875 15.859375,5.140625 C15.953125,5.234375 16,5.35416667 16,5.5 L16,6.5 C16,6.64583333 15.953125,6.765625 15.859375,6.859375 C15.765625,6.953125 15.6458333,7 15.5,7 L2.5,7 C2.35416667,7 2.234375,6.953125 2.140625,6.859375 C2.046875,6.765625 2,6.64583333 2,6.5 L2,5.5 C2,5.35416667 2.046875,5.234375 2.140625,5.140625 C2.234375,5.046875 2.35416667,5 2.5,5 L15.5,5 Z M13.5,10 C13.6458333,10 13.765625,10.046875 13.859375,10.140625 C13.953125,10.234375 14,10.3541667 14,10.5 L14,11.5 C14,11.6458333 13.953125,11.765625 13.859375,11.859375 C13.765625,11.953125 13.6458333,12 13.5,12 L0.5,12 C0.354166667,12 0.234375,11.953125 0.140625,11.859375 C0.046875,11.765625 0,11.6458333 0,11.5 L0,10.5 C0,10.3541667 0.046875,10.234375 0.140625,10.140625 C0.234375,10.046875 0.354166667,10 0.5,10 L13.5,10 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListView);
export default __webpack_public_path__ + "static/media/icon-list-view.a103fb6cee7252182d424908af8a368c.svg";
export { ForwardRef as ReactComponent };